import React, {useEffect, useState } from "react";
import Button from "../../components/common/Button";
import Input from "../../components/common/Input";
import Card from "../../components/common/Card";
import Radio from "../../components/common/Radio";
import Jumpbotron from "../../components/common/Jumpbotron";
import Select from "../../components/common/Select";
import Modal from "../../components/common/Modal";
import Tab from "../../components/common/Tab";
import { useDispatch } from "react-redux";
import { initArea, typeUsers, statusUsers } from "../../utils/options";
import CustomTable from "../../components/CustomTable";
import TableRimac from "../../components/common/Table/TableRimac";
import { hideLoading, showLoading } from "../../redux/actions/general";
import { headDataUsers } from "../../components/CustomTable/headData";
import usersData from "../../components/CustomTable/usersData";
import addUserIcon from "../../assets/icon_add_user.svg";
import deleteLogo from "../../assets/gl_delete-20.svg";
import "./styles.scss";
import { Checkbox } from "aws-amplify-react";
import { callService } from "../../amplify/callService";
import { CONSTANTES } from "../../utils/Constantes";
import Alert from "../../components/common/Alert";
import { getColorByStatusFlag } from "../../utils/utils";
import { iconEdit, iconCheck } from "../../components/common/icons";
import Chip from "../../components/common/Chip";
import Pagination from "../../components/common/Pagination";
import InputWithDropdown from "../../components/common/InputWithDropdown";

const ProveedoresValidacion = ({dataT, keyIndex, handleFinalizarFicha,  handleChangePaso, indEmpresa}) => {
  const dispatch = useDispatch();

  const [openAdd, setOpenAdd] = useState(false);
  const [tagBody, setTagBody] = useState("nostate");  
  const [showAlert, setShowAlert] = useState({
    show: false,
    title: "",
    message: "",
    type: "",
  });
  const [currentPage, setCurrentPage] = useState();
  const [paginationData, setPaginationData] = useState({
    totalPages: 5,
  });
  const [arrPerfiles, setArrPerfiles] = useState([]);
  const [arrPais, setArrPais] = useState([]);
  const [arrDepartamento, setArrDepartamento] = useState([]);
  const [arrProvincia, setArrProvincia] = useState([]);
  const [arrDistrito, setArrDistrito] = useState([]);
  const [arrTipoDoc, SetArrTipoDoc] = useState([]);
  const [arrBanco, setArrBanco] = useState([]);
  const [arrTipoCuenta, setArrTipoCuenta] = useState([]);
  const [arrArea, setArrArea] = useState([]);
  const [arrClasificacion, setArrClasificacion] = useState([]);
  const [data, setData] = useState(dataT);
  useEffect(() => {
    getPaises();
    getDepartamentos();
    getDistritos();
    getBancos();
    getTipoCuentas();
    getAreas();
    getClasificacion();
    setData(dataT);
  }, []);
  useEffect(() => {
    getPaises();
    getDepartamentos();
    getDistritos();
    getBancos();
    getTipoCuentas();
    getAreas();
    getClasificacion();    
    setData(dataT);
  }, [dataT]);
  const getPaises = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarPaises);
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.idpais,
            text: el.descpais
          };
        });
        setArrPais(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getPaises", ex);
    }
  };
  const getDepartamentos = async (ind) => {
    try {
      if((!data.idPais) && !ind){
        return true;
      }else{
        data.idPais = ind || data.idPais;
      }
        
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarDepartamentosPais.replace('{idPais}',data.idPais));
      if (response.ok && response.data && response.data.payload) {
        let departamentos = response.data.payload.map((el, index) => {
          return {
            value: el.iddepartamento,
            text: el.descdepartamento
          };
        });
        setArrDepartamento(departamentos);
      }
    } catch (ex) {
      console.log("Error al obtener getDepartamentos", ex);
    }
  };
  const getBancos = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','BANCO'));
      if (response.ok && response.data && response.data.payload) {
        let bancos = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrBanco(bancos);
      }
    } catch (ex) {
      console.log("Error al obtener getBancos", ex);
    }
  };
  const getTipoCuentas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','TIPO_CUENTA'));
      if (response.ok && response.data && response.data.payload) {
        let tipoCuentas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrTipoCuenta(tipoCuentas);
      }
    } catch (ex) {
      console.log("Error al obtener tipoCuentas", ex);
    }
  };
  const getAreas = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','AREA_PROV'));
      if (response.ok && response.data && response.data.payload) {
        let areas = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrArea(areas);
      }
    } catch (ex) {
      console.log("Error al obtener getMonedas", ex);
    }
  };
  const getClasificacion = async () => {
    try {
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarParametrosTipo.replace('{tipoParametro}','CLASIF_PROV'));
      if (response.ok && response.data && response.data.payload) {
        let clasif = response.data.payload.map((el, index) => {
          return {
            value: el.codparametro,
            text: el.descparametro
          };
        });
        setArrClasificacion(clasif);
      }
    } catch (ex) {
      console.log("Error al obtener areas", ex);
    }
  };
  const getDistritos = async (ind) => {
    try {
      if((!data.idProvincia) && !ind){
        return true;
      }else{
        data.idProvincia = ind || data.idProvincia;
      }
      let response = await callService("GET", CONSTANTES.APIS_PATH.listarDistritosProv.replace('{idProvincia}',data.idProvincia));
      if (response.ok && response.data && response.data.payload) {
        let paises = response.data.payload.map((el, index) => {
          return {
            value: el.iddistrito,
            text: el.descdistrito
          };
        });
        setArrDistrito(paises);
      }
    } catch (ex) {
      console.log("Error al obtener getDistritos", ex);
    }
  };
  const resetAlert = () => {
    setShowAlert({
      show: false,
      title: "",
      message: "",
      type: "",
    });
  };
  
  const resetForm =() => {
    
  };

  const resetMessage = (sec) =>
    setTimeout(() => {
      resetAlert();
    }, sec * 1000);
 

  const handleCloseModal = (value) => {
    setOpenAdd(value);
  };

  const handleChangeEnvioCorreo = (event) => {
    console.log('============', event)
  };

  const handleChangeEmail = (text) => {
    console.log('============', text);
    };


  const handleOpenAddModal = (tag) => {    
    setTagBody(tag);
    resetForm();
    setOpenAdd(true);
  };

  const handleShowModal = (row, tag) => {
    resetForm();
    if (!openAdd) setOpenAdd(true);
    setTagBody(tag);
    if (tag === "edit") fillEditForm(row);
  };

  const fillEditForm = (row)=> {
    console.log(row);
      
  };
  
  const handleCloseAddModal = () => {
    setOpenAdd(false);
  };

  const bodyModalAdd = () => {
    return (
      <div className="content customTable--bodyModal">
        <div className="title">
          <h4 className="title-05 margin-bottom-10">
            Registro para{" "}
            <span className="title-05 color-red">
              <strong>{ tagBody=="add" && ("agregar nueva") } { tagBody=="edit" && ("actualizar") } área</strong>
            </span>
          </h4>
        </div>
        <div className="form--line" />
        <div className="customTable--bodyModal-input">
          
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areasLay__formulario--left2Columns">
              <Input label="Nombre de área" />
            </div>
            <div className="usersLay__formulario--right2Columns">
              <Select label="Estado"  />
            </div>
            
        </div>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreo" label="Envío de Correo" />
            <label htmlFor="chkEnvioCorreo">Enviar correo de notificación</label>
            </div>
          
        </div>
        <br/>
        <div className="d-justify-space-between d-flex-column-m w100">
            <div className="areassLay__formulario--left2Columns">
            <Checkbox id="chkEnvioCorreoRecepcion" label="Envío de Correo Recepcion" />
            <label htmlFor="chkEnvioCorreoRecepcion">Correo de recepción de factura</label>
            </div>
            
            
        </div>
      
        </div>
      </div>
    );
  };  
    
  const handleClickRegisterModal = async () => {
      //const { dateTimeCreation, docNumber, clientDoc, id } = selectedRow;
    if(tagBody=="add")
    { 
        const body = {
          payload: {
            
          },
        };
        try {
          dispatch(showLoading());
          const response = await callService(
            "POST",
            CONSTANTES.APIS_PATH.insertArea,
            body
          );
          dispatch(hideLoading());
          // type == 0 => ok , type == 1 => error
          let error = response.data? response.data.type:null;
          if (response.ok && response.data && response.ok == true && error!='1') {
            resetForm();
            setShowAlert({
              show: true,
              title: "Correcto",
              message: response.data.data || "Se guardó el registró",
              type: "success",
            });
            resetMessage(5);
            handleCloseModal(false);            
            setCurrentPage(new Number(1));            
          } else {
            const mesaje = response.message || "Error al registrar";
            setShowAlert({
              show: true,
              title: "Error",
              message: mesaje,
              type: "error",
            });
            resetMessage(5);
          }
          // handleSearchEndpoint();
        } catch (ex) {
          console.log(ex)
          dispatch(hideLoading());
        }
      
    }
    
  };

  const handleSearchEndpoint = async () => {
    let payload = {
     
      
      
    };
    const fetchObj = {
      payload: payload,
    };
    dispatch(showLoading());
    const response = await callService(
      "POST",
      CONSTANTES.APIS_PATH.searchArea,
      fetchObj
    );
    dispatch(hideLoading());
    if (response.ok && response.data) {
      let { totalPages } = response.data;
      setPaginationData({ ...paginationData, totalPages: totalPages });

      let arrData =
        response &&
        response.data &&
        response.data.rows &&
        response.data.rows.map((item) => {
          let obj = {
            id: item.ID,
            dateTimeCreation: item.dateTimeCreation,
            name: item.name,
            email: item.email,
            emailRecepcion: item.emailRecepcion,
            estado: item.estado,
            sendMailValidation:  item.sendMailValidation? item.sendMailValidation: false,
            valEmailRecepcion:  item.valEmailRecepcion? item.valEmailRecepcion: false  
          };
          return obj;
        });
    } else {
      console.log("Error fetching data => ", response.message);
      
    }
  };

  return (
    <div className="step__content" data-key={keyIndex}>
      <div className="proveedores_content">          
          <h4 className="title-05 margin-bottom-16 margin-top-16">
                <p><b>Valida tu <span class="title-red">Información</span></b></p>
                <p className="title-06"><b>Importante antes de finalizar el registro del proveedor:</b></p>
          </h4>
          <br/>
          <h4 className="title-06 margin-bottom-16 margin-top-16">
              RESUMEN
          </h4>               
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_datos">
                <Card
                  title="IDENTIFICACION DE EMPRESA"
                  id="identificacion"
                  accion=""
                  body={<>
                        <div>
                          <label>
                            <span className="title-07">
                              <b>NOMBRE: </b>
                              {data.nombreRazonSocial}
                            </span>
                          </label>
                        </div>
                        <div>
                          <label>
                            <span className="title-07">
                              <b>{data.tipoDocumento+': '}</b>
                              {data.numDocumento} 
                            </span>
                          </label>
                        </div>
                        <div>
                          <label>
                            <span className="title-07">
                              <b>CLASIFICACION: </b>
                              {(arrClasificacion && data.idpClasificacion && arrClasificacion.length>0 && arrClasificacion.find(el=>el.value==data.idpClasificacion))?.text} 
                            </span>
                          </label>
                        </div>
                        </>}                          
                  handler={() => handleChangePaso(0)}                        
                />
            </div>
            <div className="documents_criteria_datos">
                <Card
                  title="UBICACION DE EMPRESA"
                  id="ubicacion"
                  accion="Editar Informacion"
                  body={<>
                      <div>
                        <label>
                          <span className="title-07">
                              <b>PAIS:</b>                          
                              {data && arrPais.find(obj=>obj.value==data.idPais)?.text}
                          </span>
                        </label>
                      </div>
                      {data.idDistrito? 
                      <>
                      <div>
                        <label>
                          <span className="title-07">
                            <b>DEPARTAMENTO:</b>
                            {data && arrDepartamento.find(obj=>obj.value==data.idDepartamento)?.text}
                          </span>
                        </label>
                      </div>
                      <div>
                        <label>
                          <span className="title-07">
                              <b>DISTRITO:</b>                          
                              {data && arrDistrito.find(obj=>obj.value==data.idDistrito)?.text}
                          </span>
                        </label>
                      </div>
                      </>:
                      <div>
                        <label>
                          <span className="title-07">
                            <b>DIRECCION:</b>
                            {data.direccion}
                          </span>
                        </label>
                      </div>
                      }                      
                      </>}                          
                  handler={() => handleChangePaso(-1)}                        
                />
            </div>
          </div>
          <br/>
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_datos">
                <Card
                  title="DATOS DE CONTACTO"
                  id="contacto"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>NOMBRES:</b>                        
                          {data.medioContacto.length>0 && data.medioContacto[0].nombres}
                        </span> 
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>CELULAR:</b>                        
                          {data.medioContacto.length>0 && data.medioContacto[0].celular}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>CORREO:</b>                        
                          {data.medioContacto.length>0 && data.medioContacto[0].correo}
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(0)}                        
                />
            </div>
            <div className="documents_criteria_datos">
                <Card
                  title="FORMA DE PAGO"
                  id="formaPago"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>BANCO:</b>                        
                          {(data.formaPago.length>0 && arrBanco.find(obj=>obj.value==data.formaPago[0].idpBanco)?.text)}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>CUENTA:</b>                        
                          {(data.formaPago.length>0 && arrTipoCuenta.find(obj=>obj.value==data.formaPago[0].idpTipoCuenta)?.text)}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>N° CUENTA:</b>                        
                          {data.formaPago.length>0 && data.formaPago[0].numCuenta}
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(1)}                        
                />
            </div>
          </div>
          <br/>
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_datos">
                <Card
                  title="REFERENCIAS"
                  id="referencias"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>RAZON SOCIAL:</b>                        
                          {data.referencia.length>0 && data.referencia[0].razonSocial}
                        </span> 
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>RUC:</b>                        
                          {data.referencia.length>0 && data.referencia[0].numRuc}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>NOMBRES:</b>                        
                          {data.referencia.length>0 && data.referencia[0].nombres}
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(2)}                        
                />
            </div>
            <div className="documents_criteria_datos">
                <Card
                  title="CONTACTO RIMAC"
                  id="contactoRimac"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>NOMBRES:</b>                        
                          {(data.contactoRimac.length>0 && data.contactoRimac[0].nombres)}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>APELLIDOS:</b>                        
                          {(data.contactoRimac.length>0 && data.contactoRimac[0].apePaterno)}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>AREA:</b>                        
                          {(data.contactoRimac.length>0 && arrArea.find(obj=>obj.value==data.contactoRimac[0].idpArea)?.text)}
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(3)}                        
                />
            </div>
          </div>
          <br/>  
          {indEmpresa && 
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_datos">
                <Card
                  title="ACCIONISTAS"
                  id="accionistas"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>{data.accionista.length>0 && (data.accionista[0].idpTipoDocumento +': ')}</b>
                          {data.accionista.length>0 && data.accionista[0].numeroDocumento}
                        </span> 
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>NOMBRES:</b>                       
                          {data.accionista.length>0 && data.accionista[0].nombres}
                        </span> 
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>CARGO:</b>                        
                          {data.accionista.length>0 && data.accionista[0].cargo}
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(4)}                        
                />
            </div>
            <div className="documents_criteria_datos">
                <Card
                  title="REPRESENTANTE LEGAL"
                  id="representanteLegal"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>{data.representante.length>0 && (data.representante[0].idpTipoDocumento +': ')}</b>
                          {data.representante.length>0 && data.representante[0].numeroDocumento}
                        </span> 
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>NOMBRES:</b>                        
                          {(data.representante.length>0 && data.representante[0].nombres)}
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          <b>CARGO:</b>                        
                          {(data.representante.length>0 && data.representante[0].cargo)}
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(5)}                        
                />
            </div>
          </div>
          }          
          <br/>
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_datos">
                <Card
                  title="INFORMACION COMPLEMENTARIA"
                  id="infoComplementaria"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          1. Indicar si es un sujeto obligado a informar a la UIF ...
                        </span> 
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          2. Antecedentes Penales ...
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          3. Temas de Investigación ...
                        </span>
                      </label>
                    </div>
                    </>}
                  handler={() => handleChangePaso(4+(indEmpresa?2:0))}                        
                />
            </div>
            <div className="documents_criteria_datos">
                <Card
                  title="PREGUNTAS"
                  id="Preguntas"
                  accion="Editar Informacion"
                  body={<>
                    <div>
                      <label>
                        <span className="title-07">
                          1. ¿Cuenta con un Código de Etica/o Conducta u otro documento ...
                        </span>
                      </label>
                    </div>
                    <div>
                      <label>
                        <span className="title-07">
                          2. ¿Los accionistas, directores, gerentes o personal involucrado ...
                        </span>
                      </label>
                    </div>                    
                    </>}
                  handler={() => handleChangePaso(5+(indEmpresa?2:0))}                        
                />
            </div>
          </div>
          <br/>
          
          <div className="d-justify-space-between d-flex-column-m w100">
            <div className="documents_criteria_btns d-flex-end margin-bottom-16">
              <div className="documents_btnSearch">
                <Button
                  // type="submit"
                  primary
                  size="large"
                  onClick={()=>{
                    handleFinalizarFicha(data);                    
                    //handleChangePaso(2);
                  }}
                >
                  Finalizar
                </Button>
              </div>                  
            </div>
          </div>
      </div>
      <div className="proveedores_margen">     
      </div>
    </div>
  );
};


export default ProveedoresValidacion;
